"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@chakra-ui/react");
var _template = _interopRequireDefault(require("lodash/template"));
var _environment = _interopRequireDefault(require("@spothero/utils/environment"));
var _excluded = ["isSSR", "cloudinaryImageId", "cloudinaryTemplate", "cloudinaryCloudName", "htmlWidth", "htmlHeight", "quality", "lazyLoad"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context3, _context4; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context3 = ownKeys(Object(t), !0)).call(_context3, function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context4 = ownKeys(Object(t))).call(_context4, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var buildCloudinarySrc = function buildCloudinarySrc(_ref) {
  var _context, _context2;
  var cloudinaryImageId = _ref.cloudinaryImageId,
    cloudinaryTemplate = _ref.cloudinaryTemplate,
    cloudinaryCloudName = _ref.cloudinaryCloudName,
    htmlWidth = _ref.htmlWidth,
    htmlHeight = _ref.htmlHeight,
    quality = _ref.quality;
  var defaultTemplate = (0, _concat["default"])(_context = (0, _concat["default"])(_context2 = "https://res.cloudinary.com/".concat(cloudinaryCloudName, "/image/upload/$w_{{WIDTH}},$h_{{HEIGHT}},$q_{{QUALITY}}/c_fill,f_auto,fl_progressive,dpr_")).call(_context2, _environment["default"].isHighDensityDisplay() ? 2 : 1, ",h_$h,q_$q,w_$w/")).call(_context, cloudinaryImageId);
  var tmpl = cloudinaryTemplate ? cloudinaryTemplate : defaultTemplate;
  return (0, _template["default"])(tmpl, {
    interpolate: /{{([\s\S]+?)}}/g // matches template vars in the format '{{ var }}' or '{{var}}'
  })({
    WIDTH: htmlWidth,
    HEIGHT: htmlHeight,
    QUALITY: quality
  });
};
var Image = function Image(_ref2) {
  var isSSR = _ref2.isSSR,
    cloudinaryImageId = _ref2.cloudinaryImageId,
    cloudinaryTemplate = _ref2.cloudinaryTemplate,
    cloudinaryCloudName = _ref2.cloudinaryCloudName,
    htmlWidth = _ref2.htmlWidth,
    htmlHeight = _ref2.htmlHeight,
    quality = _ref2.quality,
    lazyLoad = _ref2.lazyLoad,
    otherProps = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var hasValidCloudinarySrc = (cloudinaryImageId || cloudinaryTemplate) && Boolean(htmlWidth) && Boolean(htmlHeight);
  var cloudinarySrc;
  if (hasValidCloudinarySrc) {
    cloudinarySrc = buildCloudinarySrc({
      cloudinaryImageId: cloudinaryImageId,
      cloudinaryTemplate: cloudinaryTemplate,
      cloudinaryCloudName: cloudinaryCloudName,
      htmlWidth: htmlWidth,
      htmlHeight: htmlHeight,
      quality: quality
    });
  }
  var imageProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    src: cloudinarySrc || otherProps.src,
    htmlWidth: htmlWidth,
    htmlHeight: htmlHeight
  }, lazyLoad && {
    loading: 'lazy'
  });
  if (isSSR) {
    return /*#__PURE__*/_react["default"].createElement(_react2.Img, imageProps);
  } else {
    return /*#__PURE__*/_react["default"].createElement(_react2.Image, imageProps);
  }
};
Image.defaultProps = {
  isSSR: false,
  quality: 50,
  cloudinaryCloudName: 'spothero'
};
var _default = exports["default"] = Image;